import ReferralBusiness from '@/pages/ReferralProgram/ReferralBusiness/ReferralBusiness';
import type { RouteConfig } from '@/types/routestypes'
import { lazy } from 'react';


const Referral = lazy(() => import("@/pages/ReferralProgram/Referral"));

const ReferralProgramRoute: RouteConfig = {

    path: "",
    pageName: "Referral Program",
    sidebar: {
        show: true,
        icon: "/assets/media/referal copy.svg",
    },
    permission: ["ReferralView", "ViewBusiness"],
    children: {
        Referral: {
            path: "myreferral",
            element: <Referral />,
            pageName: "Referral",
            sidebar: { show: true },
            permission: ["ReferralView"],
        },
        ReferralBusiness: {
            path: "mybusiness",
            element: <ReferralBusiness />,
            pageName: "Referral Business",
            sidebar: { show: true },
            permission: ["ViewBusiness"],
        },
    }
}

export default ReferralProgramRoute;
